import { useMemo } from 'react';
import { useMutationState, type MutationKey } from '@tanstack/react-query';

/**
 * Ids of the rows with a request under `mutationKey` still in flight. Read from
 * the mutation cache rather than one hook's `variables`, which only remember
 * the latest call: a second row's action must not clear the first row's state.
 */
export function usePendingRowIds(
  mutationKey: MutationKey,
  toRowId: (variables: unknown) => string = String
): ReadonlySet<string> {
  const pendingIds = useMutationState({
    filters: { mutationKey, status: 'pending' },
    select: (mutation) => toRowId(mutation.state.variables)
  });
  return useMemo(() => new Set(pendingIds), [pendingIds]);
}
